﻿import { defineComponent } from 'vue';
import { Booking } from "../../services/booking";
import { Product } from "../../services/product";
import Banner from '../base/common/banner.vue'

const Prod = new Product();

export default defineComponent({
    components: {
        Banner
    },
    props: {
        // the checkout page (4_check_out.vue) has no cart button
        hide_cart: Boolean
    },
    data() {
        return {
            isActive: false,
            isActive_Agency: false,
            mobileMenuOpen: false,
            showCart: false,
            isStuck: false,
            stickyObserver: null as IntersectionObserver | null,
        }
    },
    methods: {
        show_welcome_banner(): boolean {
            return import.meta.env.VITE_SHOW_WELCOME_BANNER === 'true';
        },
        cart_count(): number {

            if ((this.$store.getters.get_Basket.trips.length == 1) && (this.$store.getters.get_Basket.trips[0].tour_id == "")) {
                return 0;
            }

            const Book = new Booking();
            return this.$store.getters.get_Basket.trips.length + Book.getTotal_Add_Ons(this.$store.getters.get_Basket);

        },
        cart_has_items(): boolean {
            return this.cart_count() > 0;
        },
        // hidden on the agent portal until the agent has logged in, and wherever hide_cart is set
        show_cart(): boolean {
            if (this.hide_cart) {
                return false;
            }
            return this.isConsumer_Login() || this.isAgent_Login();
        },
        cart_trips(): any[] {
            return (this.$store.getters.get_Basket?.trips ?? []).filter((trip: any) => (trip.tour_id ?? "") != "");
        },
        get_Tour_Details(tour_id: string) {
            return Prod.Get_Details_Sync(tour_id, this.$store);
        },
        get_Tour_Image(tour_id: string): string {
            return this.get_Tour_Details(tour_id)?.marketing_information?.media?.[0]?.assets?.[0]?.asset_url ?? "";
        },
        get_Logo(): string {
            return String(import.meta.env.VITE_DEFAULT_LOGO);
        },
        // Optional white/light logo used when the nav sits transparently over a hero image.
        // Without one, the normal logo is shown on a white tile there so it stays readable.
        has_Light_Logo(): boolean {
            return import.meta.env.VITE_DEFAULT_LOGO_LIGHT != undefined && import.meta.env.VITE_DEFAULT_LOGO_LIGHT != "";
        },
        get_Logo_Light(): string {
            return String(import.meta.env.VITE_DEFAULT_LOGO_LIGHT);
        },
        Has_second_logo(): boolean {
            return import.meta.env.VITE_DEFAULT_LOGO_TWO != undefined;
        },
        get_Logo_Two(): string {
            return String(import.meta.env.VITE_DEFAULT_LOGO_TWO);
        },
        get_phone_number(): string {
            return String(import.meta.env.VITE_DEFAULT_PHONE_NUMBER);
        },
        get_phone_reference(): string {
            let phone = String(import.meta.env.VITE_DEFAULT_PHONE_NUMBER);
            return "tel:" + phone.replace(/[^0-9]/g, "");
        },
        show_nav_link(): boolean {
            return import.meta.env.VITE_SHOW_NAVBAR_LINKS === 'true';
        },
        isAgent_Login(): boolean {
            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        isAAT(): boolean {
            if (import.meta.env.VITE_DEFAULT_PARENT == "AAT") {
                return true;
            }
            return false;
        },
        isConsumer_Login(): boolean {
            return import.meta.env.VITE_AGENT_IDENTITY_URL == undefined;
        },
        Go_Home() {
            this.$router.push('/')
        },
        My_Profile() {
            this.$router.push('/my_profile')
        },
        Manage_Bookings() {
            this.$router.push('/manage_bookings')
        },
        Log_Out() {
            this.$store.commit("Logout_Agent");
            this.$router.push('/login');
        },
        Cart() {
            this.$router.push('/cart');
        },
        Logo_Click() {
            if(import.meta.env.VITE_BASE_SITE_URL != undefined && import.meta.env.VITE_BASE_SITE_URL != "")
            {
                window.location.href = import.meta.env.VITE_BASE_SITE_URL;
            }
            else
            {
                this.$router.push('/');
            }
        },
        isMobile(): boolean{
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        }
    },
    mounted() {
        // stick the nav to the top once its original position has scrolled out of view
        const sentinel = this.$refs.sentinel as HTMLElement | undefined;
        if (sentinel && "IntersectionObserver" in window) {
            this.stickyObserver = new IntersectionObserver(([entry]) => {
                this.isStuck = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            });
            this.stickyObserver.observe(sentinel);
        }
    },
    beforeUnmount() {
        this.stickyObserver?.disconnect();
    }
})